import { render, staticRenderFns } from "./PagePushNotificationsSettings.vue?vue&type=template&id=bde4b204&scoped=true&"
import script from "./PagePushNotificationsSettings.vue?vue&type=script&lang=ts&"
export * from "./PagePushNotificationsSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PagePushNotificationsSettings.vue?vue&type=style&index=0&id=bde4b204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde4b204",
  null
  
)

export default component.exports